<template>
  <section>
    <div class="left">
      <h2 v-translate>Poskytovatelé videí videotéky</h2>
    </div>
    <div class="right checkbox_group">
      <div class="package_box_wrapper">
        <div class="package_box" v-for="(provider, key) in vodProviders" :key="'vod_provider_'+key">
          <p class="field package_box_name">
            <input
                :id="'vodproviders_' + key"
                :name="'vodproviders_' + key"
                type="checkbox"
                :value="provider.id"
                v-model="selectedIds"
                :disabled="!isEditable"
            />
            <label :for="'vodproviders_' + key">{{ provider.text }}</label>
          </p>
          <p><strong v-translate>Viditelnost nezakoupených balíčků</strong></p>
          <p class="field" v-for="vodPackage in provider.package_visibility" :key="'package_'+vodPackage.id">
            <select-box
                :id="'package_visibility_'+vodPackage.id"
                :options="nullableBooleanOptions"
                :disabled="!isEditable || !selectedIds.includes(provider.id)"
                v-model="packageVisibility[provider.id][vodPackage.id]"
                @input="onPackageVisibilityChange()"
            >
              <span class="translate">{{ vodPackage.text }}</span>
            </select-box>
          </p>
        </div>
      </div>
    </div>
    <div v-if="!hasVodProviders" class="right" v-translate>Aktuálně nejsou dostupní žádní poskytovatelé videí videotéky</div>
  </section>
</template>

<script>
import {getCorrectBooleanValue} from "@/utils/helpers"

export default {
  name: "VodProviders",
  props: {
    entity: Object,
    idBusinessModel: Number,
    isEditable: Boolean,
  },
  data() {
    return {
      vodProviders: [],
      packageVisibility: {},
    }
  },
  created(VodProviderService) {
    this.vodProviderService = VodProviderService;
    this.vodProviderService.getListWithPackagesVisibility({'id_business_model': this.idBusinessModel})
        .then((data) => {
          this.vodProviders = data['vodProviders'];
          this.vodProviders.forEach((provider) => {
            this.packageVisibility[provider.id] = {};
            provider.package_visibility.forEach((vodPackage) => {
              this.packageVisibility[provider.id][vodPackage.id] = vodPackage.business_model;
            })
          });
        })
  },
  computed: {
    hasVodProviders(){
      return this.vodProviders.length > 0;
    },
    selectedIds: {
      get() {
        return this.entity.vod_providers;
      },
      set(value) {
        this.entity.vod_providers = value;
      }
    },
    nullableBooleanOptions() {
      var result = [
        {id: true, text: this.$gettext('Ano')},
        {id: false, text: this.$gettext('Ne')},
      ];
      return result;
    },
  },
  methods: {
    onPackageVisibilityChange(){
      this.$nextTick(() => {
        let result = {};
        for(let i in this.packageVisibility){
          let packages = {};
          for(let j in this.packageVisibility[i]){
            packages[j] = getCorrectBooleanValue(this.packageVisibility[i][j]);
          }
          result[i] = {'package_visibility': packages}
        }
        this.entity.vod_package_settings = result;
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/businessModels/Forms/VodProviders.vue